/**
 * Platform-aware Zustand persist storage adapter.
 * Web: synchronous localStorage.
 * Mobile: AsyncStorage (lazy-required to avoid bundling native modules on web).
 */

import { Platform } from 'react-native';
import type { StateStorage } from 'zustand/middleware';

export const platformStorage: StateStorage = Platform.OS === 'web'
  ? {
      getItem: (key: string) => {
        try { return window.localStorage.getItem(key); } catch { return null; }
      },
      setItem: (key: string, value: string) => {
        try { window.localStorage.setItem(key, value); } catch { /* quota / private mode */ }
      },
      removeItem: (key: string) => {
        try { window.localStorage.removeItem(key); } catch { /* ignore */ }
      },
    }
  : {
      getItem: (key: string) => {
        // eslint-disable-next-line @typescript-eslint/no-require-imports
        const AsyncStorage = require('@react-native-async-storage/async-storage').default;
        return AsyncStorage.getItem(key);
      },
      setItem: (key: string, value: string) => {
        // eslint-disable-next-line @typescript-eslint/no-require-imports
        const AsyncStorage = require('@react-native-async-storage/async-storage').default;
        return AsyncStorage.setItem(key, value);
      },
      removeItem: (key: string) => {
        // eslint-disable-next-line @typescript-eslint/no-require-imports
        const AsyncStorage = require('@react-native-async-storage/async-storage').default;
        return AsyncStorage.removeItem(key);
      },
    };
